"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const services_1 = require("services");
const icons_1 = __importDefault(require("constants/icons"));
const context_1 = require("components/context");
const hooks_1 = require("components/hooks");
const Account = ({ navigation }) => {
    const client = (0, hooks_1.useClient)();
    const [clientData, setClientData] = React.useState(null);
    const authContext = React.useContext(context_1.AuthContext);
    React.useEffect(() => {
        const onSuccess = (response) => {
            setClientData(response?.data);
        };
        const onFailSessionExpired = authContext?.signOut;
        //doCliente({
        //	onSuccess: onSuccess,
        //});
        (0, services_1.doPerfil)({
            callback: {
                onSuccess,
                onFailSessionExpired,
            },
        });
    }, [client?.id]);
    const onClientPressed = () => {
        navigation.navigate("AccountClientDataName");
    };
    const onDiscountsPressed = () => {
        navigation.navigate("AccountDiscountsName");
    };
    const onPlanPressed = () => {
        navigation.navigate("AccountPlanTacticoName");
    };
    return (<native_base_1.ScrollView style={{ width: "100%" }} _contentContainerStyle={{
            alignItems: "center",
            px: {
                base: 0,
                md: 0,
            },
        }}>
			<native_base_1.View w={{ base: "100%", md: "90%", lg: "75%", xl: "65%" }} pb="10">
				<native_base_1.VStack mt="30">
					<AccountFieldValue icon={icons_1.default.icAccountClientData} field={"Datos del cliente"} onPressed={onClientPressed}/>
					<AccountFieldValue icon={icons_1.default.icAccountDiscounts} field={theme_1.Str.discounts} onPressed={onDiscountsPressed}/>
					{(clientData?.descuentos?.length ?? 0) > 0 && authContext?.loginData?.uidtipo == "RV" && (
        //descuentos
        <AccountFieldValue icon={icons_1.default.icAccountPlanTactico} field={"Plan Táctico"} onPressed={onPlanPressed}/>)}
				</native_base_1.VStack>
			</native_base_1.View>
		</native_base_1.ScrollView>);
};
const AccountFieldValue = props => {
    return (<native_base_1.Pressable onPress={props.onPressed}>
			<native_base_1.HStack px="20" borderBottomWidth={2} borderBottomColor="colorLightGray1" minH={50} alignItems="center">
				<native_base_1.Image source={props.icon} w={20} height={20}/>
				<native_base_1.Text mx="10" minW={160}>
					{props.field}
				</native_base_1.Text>
				<native_base_1.Image source={icons_1.default.icNext} w={20} height={20} style={{ tintColor: theme_1.Colors.colorTextPrimary }}/>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
exports.name = "AccountName";
exports.default = Account;
